import { Route } from '@angular/router';
import { LogInPageService } from './log-in-page.service';

export const logInPageRouteConfig: Route = {
  path: 'log-in',
  loadComponent: () => import('./log-in-page.component').then((c) => c.LogInPageComponent),
  providers: [LogInPageService]
};
